import { createRouter, createWebHistory } from 'vue-router'
import { homeDir, meta } from '@/utils/define'

type RouteMeta = {
  title?: string
  description?: string
}

const routes = [
  {
    path: `${homeDir}`,
    name: 'home',
    component: () => import('@/components/views/HomePage.vue'),
    meta: { title: meta.title, description: meta.description.top },
  },
  {
    path: `${homeDir}/result-1/`,
    name: 'result1',
    component: () => import('@/components/views/Result1Page.vue'),
    meta: {
      title: `茶々水 | ${meta.title}`,
      description: meta.description.result,
    },
  },
  {
    path: `${homeDir}/result-2/`,
    name: 'result2',
    component: () => import('@/components/views/Result2Page.vue'),
    meta: {
      title: `緑香 | ${meta.title}`,
      description: meta.description.result,
    },
  },
  {
    path: `${homeDir}/result-3/`,
    name: 'result3',
    component: () => import('@/components/views/Result3Page.vue'),
    meta: {
      title: `焙薫 | ${meta.title}`,
      description: meta.description.result,
    },
  },
  {
    path: `${homeDir}/result-4/`,
    name: 'result4',
    component: () => import('@/components/views/Result4Page.vue'),
    meta: {
      title: `濃緑 | ${meta.title}`,
      description: meta.description.result,
    },
  },
  {
    path: `${homeDir}/result-5/`,
    name: 'result5',
    component: () => import('@/components/views/Result5Page.vue'),
    meta: {
      title: `清爽 | ${meta.title}`,
      description: meta.description.result,
    },
  },
  {
    path: `${homeDir}/result-6/`,
    name: 'result6',
    component: () => import('@/components/views/Result6Page.vue'),
    meta: {
      title: `カモミール焙じ茶 | ${meta.title}`,
      description: meta.description.result,
    },
  },
  {
    path: `${homeDir}/result-7/`,
    name: 'result7',
    component: () => import('@/components/views/Result7Page.vue'),
    meta: {
      title: `柚子 | ${meta.title}`,
      description: meta.description.result,
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const meta = to.meta as RouteMeta

  if (meta.title) {
    document.title = meta.title as string
  }
  if (meta.description) {
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', meta.description as string)
    } else {
      const metaElement = document.createElement('meta')
      metaElement.setAttribute('name', 'description')
      metaElement.setAttribute('content', meta.description as string)
      document.head.appendChild(metaElement)
    }
  }

  next()
})

export default router
